export default {
  getStoreItems: (inputStr: string, lang: string, limit: number) =>
    `/store-item/list/${inputStr}/${lang}/${limit}`,
  getSellingUnits: (storeItemId: number, lang: string) =>
    `/selling-unit/listByStoreItem/${storeItemId}/${lang}`,
  getSizeQualifiers: (storeItemId: number, sellingUnitId: number, lang: string) =>
    `/store-item/listSizeQualifierTypeOther/${storeItemId}/${sellingUnitId}/${lang}`,
  qualifyPrice: (storeItemId: number, price: number, quantity: number, sellingUnitId: number, sizeQualifierId: number, regionId: number, date: string) =>
    `/store-item-price/computeQualifierPrice/${storeItemId}/${price}/${quantity}/${sellingUnitId}/${sizeQualifierId}/${regionId}/${date}`,
  getPlusP0: (lang: string) => lang === 'fr'
    ? '/aubaines-circulaires-supermarches/?lang=fr'
    : '/grocery-flyers-savings/',
  getHelpVideo: (lang: string) => lang === 'fr'
    ? 'https://www.soscuisine.com/click.php?id=1079'
    : 'https://www.soscuisine.com/click.php?id=1081',
  getWebpage: (lang: string) => lang === 'fr'
    ? '/evaluateur-prix-epicerie/?lang=fr'
    : '/grocery-price-checker/'
}
